export type ReceivedProps = Record<string, any>;

const useProjectManagementStatus = (props: ReceivedProps) => {
  return {
    ...props,
  };
};

export type Props = ReturnType<typeof useProjectManagementStatus>;

export default useProjectManagementStatus;
